import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import Drawer from 'material-ui/Drawer';
import { List, ListItem, ListItemIcon, ListItemText } from 'material-ui/List';
import Divider from 'material-ui/Divider';

// Icons
import DeleteIcon from 'material-ui-icons/Delete';
import ReportIcon from 'material-ui-icons/Report';
import PersonIcon from 'material-ui-icons/Person';
import BuildIcon from 'material-ui-icons/Code';

// Components
import CandidateItem from './components/CandidateItem';

// Actions
import { openOverlay, closeActionsDrawer, openPrioritiesDrawer } from './actions';

class ActionsDrawer extends Component {

  onProfiles = (url) => {

    window.location.href = url;
  }

  render(){
    const { classes, theme, location, data } = this.props;

    let profile_url = "";
    if (data) {
      profile_url = data["profile url"];
    }


    const actionsList = (
      <div className={classes.listFull}>
        <Typography type="subheading" color="inherit" className={classes.drawerTitle}>
          Tap an Action
        </Typography>
        <div className={classes.items}>
            <CandidateItem data={data}/>
        </div>
        <Divider />
        <div className={classes.buttons}>
          <ListItem button onClick={() => this.props.openPrioritiesDrawer()}>
            <ListItemIcon>
              <ReportIcon />
            </ListItemIcon>
            <ListItemText primary="Priority" />
          </ListItem>
          <ListItem button onClick={()=> this.onProfiles(profile_url)}>
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText primary="Profiles" />
          </ListItem>
          <ListItem button onClick={()=> this.onProfiles(profile_url)}>
            <ListItemIcon>
              <BuildIcon />
            </ListItemIcon>
            <ListItemText primary="Communicate" />
          </ListItem>
          <ListItem button onClick={() => this.props.openOverlay()}>
            <ListItemIcon>
              <DeleteIcon />
            </ListItemIcon>
            <ListItemText primary="Omit" />
          </ListItem>
        </div>
        <div className={classes.cancel}>
          <Button color="primary" className={classes.buttonCancel} onClick={() => this.props.closeActionsDrawer(data)}>
            Cancel
          </Button>
        </div>
      </div>
    );

    return(
      <div>
        <Drawer
          anchor="bottom"
          open={this.props.actions}
          onRequestClose={() => this.props.closeActionsDrawer(data)}
        >
          <div
            onClick={() => this.props.closeActionsDrawer(data)}
            onKeyDown={() => this.props.closeActionsDrawer(data)}
          >
          {actionsList}
          </div>
        </Drawer>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
        router: state.router,
        actions: state.dashboard.actions_open,
        data: state.dashboard.actions_data,
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        closeActionsDrawer: closeActionsDrawer,
        openPrioritiesDrawer: openPrioritiesDrawer,
        openOverlay: openOverlay,
    }, dispatch);
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, matchDispatchToProps)(ActionsDrawer)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/ActionsDrawer/index.js